import { useCallback } from 'react';

import { Sentry } from '@littleotter/zz-platform/react';

export const useClearSentryUser = () => {
  const client = Sentry.getClient();

  const clearSentryUser = useCallback(() => {
    // If there is no client, we can't set the user context
    // This is not an error, Sentry might not be enabled or initialized, so we just return early
    if (!client) {
      return;
    }
    Sentry.setUser(null);
  }, [client]);

  return { clearSentryUser };
};
